const apiKey = import.meta.env.VITE_AUTHENTICATION_API_KEY;

if (!apiKey) {
  throw new Error("API Key is missing from environment variables.");
}

const createTypebot = async (
  instanceId: string | undefined,
  debounceTime: string,
  delayMessage: string,
  description: string,
  enabled: boolean,
  expire: string,
  keepOpen: boolean,
  keywordFinish: string,
  listeningFromMe: boolean,
  stopBotFromMe: boolean,
  triggerOperator: string,
  triggerType: string,
  triggerValue: string,
  typebot: string,
  unknownMessage: string
): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/typebot/create/${instanceId}`, {
      method: 'POST',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        debounceTime: Number(debounceTime),
        delayMessage: Number(delayMessage),
        description,
        enabled,
        expire: Number(expire),
        keepOpen,
        keywordFinish,
        listeningFromMe,
        stopBotFromMe,
        triggerOperator,
        triggerType,
        triggerValue,
        typebot,
        unknownMessage,
        url: 'https://chat.cabanalink.com',
      })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao criar Typebot:', error);
  }
};

const findAllTypebots = async (instanceId: string | undefined): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/typebot/find/${instanceId}`, {
      method: 'GET',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao encontrar Typebot:', error);
  }
};

const findTypebot = async (instanceId: string | undefined, id: string): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/typebot/fetch/${id}/${instanceId}`, {
      method: 'GET',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao encontrar Typebot:', error);
  }
};

const updateTypebot = async (
  instanceId: string | undefined,
  id: string,
  debounceTime: string,
  delayMessage: string,
  description: string,
  enabled: boolean,
  expire: string,
  keepOpen: boolean,
  keywordFinish: string,
  listeningFromMe: boolean,
  stopBotFromMe: boolean,
  triggerOperator: string,
  triggerType: string,
  triggerValue: string,
  typebot: string,
  unknownMessage: string
): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/typebot/update/${id}/${instanceId}`, {
      method: 'PUT',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        debounceTime,
        delayMessage,
        description,
        enabled,
        expire,
        keepOpen,
        keywordFinish,
        listeningFromMe,
        stopBotFromMe,
        triggerOperator,
        triggerType,
        triggerValue,
        typebot,
        unknownMessage,
        url: 'https://chat.cabanalink.com',
      })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao atualizar Typebot:', error);
  }
};

const deleteTypebot = async (instanceId: string | undefined, id: string): Promise<any> => {
  try {
    const response = await fetch(`https://evolutionapi.cabanalink.com/typebot/delete/${id}/${instanceId}`, {
      method: 'DELETE',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao encontrar Typebot:', error);
  }
};

//TRATANDO WORKSPACES

const getWorkspaces = async () => {
  try {
    const response = await fetch("/api/trpc/workspace.listWorkspaces", {
      method: 'GET',
      headers: {
        "Content-Type": 'application/json',
        "Authorization": 'Bearer eoUVIh6v1PuySAvMtXIC5bZH',
      }
    })
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao encontrar Workspaces:", error);
  }
};

const inviteToWorkspace = async (userEmail: string) => {
  const data = await getWorkspaces();
  const workspaceId = data.result.data.json.workspaces.find(
    (workspace: any) => workspace.name === userEmail
  ).id;

  try {
    await fetch(`/api/workspaces/${workspaceId}/invitations`, {
      method: 'POST',
      headers: {
        "Content-Type": 'application/json',
        "Authorization": 'Bearer eoUVIh6v1PuySAvMtXIC5bZH',
      },
      body: JSON.stringify({
        "email": userEmail,
        "type": "MEMBER",
        "workspaceId": workspaceId,
      })
    })
    console.log("Convite enviado com sucesso!");
    
  } catch (error) {
    console.error("Erro ao convidar o usuário:", error);
  }
};

const createWorkspace = async (userEmail: string) => {
  if (!userEmail) return;
  const data = await getWorkspaces();

  if (data.result.data.json.workspaces.some(
    (workspace: any) => workspace.name === userEmail
  )) return;

  try {
    await fetch("/api/trpc/workspace.createWorkspace?batch=1", {
      method: 'POST',
      headers: {
        "Content-Type": 'application/json',
        "Authorization": 'Bearer eoUVIh6v1PuySAvMtXIC5bZH',
      },
      body: JSON.stringify({
        "0": {
          "json": {
            "name": userEmail,
          }
        },
        "batch": 1
      })
    });

    console.log('Workspace criado com sucesso!');
    await inviteToWorkspace(userEmail);
  } catch (error) {
    console.error("Erro ao criar o typebot:", error);
  }
}

export { createTypebot, findAllTypebots, findTypebot, updateTypebot, deleteTypebot, createWorkspace };